__turbopack_context__.v({
  "anchor": "fx4MOW_anchor",
  "calloutDismiss": "fx4MOW_calloutDismiss",
  "calloutText": "fx4MOW_calloutText",
  "calloutTip": "fx4MOW_calloutTip",
  "popup": "fx4MOW_popup",
  "trigger": "fx4MOW_trigger",
});
